<script>
import api from '@utils/api'

export default {
  name: 'SpecificationDelete',
  props: {
    specificationId: {
      type: Number,
      required: true,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
    }
  },
  methods: {
    deleteSpecification() {
      this.loading = true
      api.deleteSpecification(this.specificationId).then(response => {
        this.dialog = false
        this.loading = false
        this.$emit('spec-deleted')
      })
    },
  },
}
</script>

<template>
  <v-layout row>
    <v-btn
      slot="activator"
      :disabled="disabled"
      color="error"
      flat
      icon
      @click.native.stop="dialog = true">
      <v-icon>delete</v-icon>
    </v-btn>
    <v-dialog
      v-model="dialog"
      max-width="355">
      <v-card>
        <v-card-title class="headline text-xs-center">
          <v-spacer />
          Delete specification #{{ specificationId }}
          <v-spacer />
        </v-card-title>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            :disabled="loading"
            color="secondary"
            @click.native="dialog = false"
          >
            {{ $t('buttons__cancel') }}
          </v-btn>
          <v-btn
            :disabled="loading"
            :loading="loading"
            color="error"
            @click.native="deleteSpecification"
          >
            {{ $t('buttons__delete') }}
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<style lang="scss" module>
@import '@design';
</style>
